module.exports = __webpack_public_path__ + "img/iconliterature.7715d77e.png";